{/* TEP-16571 訪客購物 start */ }
import Background from "../Background/Background";
import BottomDrawer from "../bottomDrawer/bottomDrawer";
import ModalWrapper from "../ModalWrapper/ModalWrapper";
import Breakpoint from "@tw/style-guide/lib/components/utilities/breakpoint";
import { SHOW_SOP_ORDER_REMINDER } from "../..//utils/Constants/Constants";
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getLoggedInUserInfo } from '../../utils/helper';
import { fetchGuestContentStackWriting } from "../../redux/reducers";

import styles from "./index.scss";
const Index = props => {
  const {
    modalWidth,
    modalHeight,
    onClose
  } = props;
  const [breakpoint, setBreakpoint] = useState("xs");
  const isDesktop = breakpoint !== "xs" && breakpoint !== "sm";
  const [openModal, setOpenModal] = useState(false)
  const [modalData, setModalData] = useState(null)
  useEffect(() => {
    if (
      typeof window !== undefined &&
      typeof window !== "undefined"
    ) {
      /**
       * 1、判断弹框是否弹出过
       * 2、判断浏览器 URL 中是否包含分享购特定参数
       * 3、判断当前用户是否已经登录了
      */
      const { role, loginAda } = getLoggedInUserInfo()
      const showSopOrderReminder = sessionStorage.getItem(SHOW_SOP_ORDER_REMINDER) ? JSON.parse(sessionStorage.getItem(SHOW_SOP_ORDER_REMINDER)) : false
      const { d, utm_campaign, utm_medium, utm_source } = getQueryParams();
      if (
        showSopOrderReminder == false &&
        d &&
        utm_campaign &&
        utm_medium &&
        utm_source &&
        (role == "Guest" || role == "FOA") &&
        loginAda == ""
      ) {
        initComponents()
      }
    }
  }, [])
  // 初始化組件&調用CS配置文案
  const initComponents = async () => {
    await fetchGuestContentStackWriting().then((res) => {
      if (res.status == 200) {
        setModalData(res.data)
        setOpenModal(true)
      }
    })
  }
  // 获取 URL 全部参数
  const getQueryParams = () => {
    // 获取当前页面的完整 URL
    const url = window.location.href;

    // 使用 URLSearchParams 对象解析查询字符串
    const params = new URLSearchParams(new URL(url).search);

    // 创建一个空对象来存储参数
    const queryParams = {};

    // 遍历参数并添加到对象中
    for (const [key, value] of params.entries()) {
      queryParams[key] = value;
    }

    return queryParams;
  }
  // 關閉彈窗回調
  const close = () => {
    onClose()
    setOpenModal(false)
    sessionStorage.setItem(SHOW_SOP_ORDER_REMINDER, true)
  }
  // 點擊同意按鈕回調
  const onRemoveCartSOPCommodity = () => {
    setOpenModal(false)
    sessionStorage.setItem(SHOW_SOP_ORDER_REMINDER, true)
  }
  return (
    <>
      <Breakpoint onBreakpointChange={setBreakpoint} />
      {
        isDesktop ?
          openModal && <Background>
            <ModalWrapper modalWidth={modalWidth}>
              <div className={styles.header_PC}>
                <div className={styles.header_left}>{modalData?.title}</div>
                <div className={styles.header_right} onClick={close}><CloseIcon /></div>
              </div>
              <div className={styles.GuestLoginModal_PC}>
                <div className={styles.GuestLoginModal_Content}>
                  <div className={styles.GuestLoginModal_Content_Icon}><EmphasisIcon /></div>
                  <div dangerouslySetInnerHTML={{ __html: modalData?.content }}></div>
                </div>
                <div className={styles.GuestLoginModal_Footer}>
                  <div className={styles.agreed_Btn} onClick={onRemoveCartSOPCommodity}>{modalData?.single_line_textbox}</div>
                </div>
              </div>
            </ModalWrapper>
          </Background>
          :
          <BottomDrawer open={openModal} setOpen={close}>
            <div className={styles.header_Mobile} style={{ height: modalHeight }}>
              <div className={styles.header_left}>{modalData?.title}</div>
              <div className={styles.header_right}></div>
            </div>
            <div className={styles.GuestLoginModal_Mobile}>
              <div className={styles.GuestLoginModal_Content}>
                <div className={styles.GuestLoginModal_Content_Icon}><ReminderIcon /></div>
                <div className={styles.GuestLoginModal_Content_children} dangerouslySetInnerHTML={{ __html: modalData?.content }}></div>
              </div>
              <div className={styles.GuestLoginModal_Footer}>
                <div className={styles.agreed_Btn} onClick={onRemoveCartSOPCommodity}>{modalData?.single_line_textbox}</div>
              </div>
            </div>
          </BottomDrawer>
      }
    </>
  );
};
//API
Index.defaultProps = {
  //  訪問設備
  isDesktop: true,
  //  PC 彈出窗寬度
  modalWidth: "460px",
  //  彈出窗寬度
  modalHeight: "",
  //  是否显示
  openModal: false,
  //  内容
  children: null,
  //  关闭按钮回调
  onClose: () => { }
};

//參數類型
Index.propTypes = {
  isDesktop: PropTypes.bool,
  modalWidth: PropTypes.string,
  openModal: PropTypes.bool,
  children: PropTypes.node,
  onClose: PropTypes.func
};
export default Index;
{/* TEP-16571 訪客購物 End */ }

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.3473 11.9752L19.7165 6.60598C20.027 6.29545 20.027 5.79153 19.7165 5.4805L18.4689 4.2329C18.1584 3.92237 17.6545 3.92237 17.3434 4.2329L11.9747 9.60262L6.60548 4.2334C6.29495 3.92287 5.79103 3.92287 5.48 4.2334L4.2329 5.4805C3.92237 5.79103 3.92237 6.29495 4.2329 6.60598L9.60212 11.9752L4.2329 17.3444C3.92237 17.655 3.92237 18.1589 4.2329 18.4699L5.4805 19.7175C5.79103 20.028 6.29495 20.028 6.60598 19.7175L11.9747 14.3478L17.3439 19.717C17.6545 20.0275 18.1584 20.0275 18.4694 19.717L19.717 18.4694C20.0275 18.1589 20.0275 17.655 19.717 17.3439L14.3473 11.9752Z" fill="#2C2C2C" />
  </svg>
)
const EmphasisIcon = () => (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22" cy="22" r="21" stroke="#292929" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="22" y="32" width="0.01" height="0.01" stroke="#292929" strokeWidth="3" strokeLinejoin="round" />
    <path d="M22 27L22 12" stroke="#292929" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
const ReminderIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 0.25C12.25 0.25 15.75 3.75 15.75 8C15.75 12.2812 12.25 15.75 8 15.75C3.71875 15.75 0.25 12.2812 0.25 8C0.25 3.75 3.71875 0.25 8 0.25ZM8 14.25C11.4375 14.25 14.25 11.4688 14.25 8C14.25 4.5625 11.4375 1.75 8 1.75C4.53125 1.75 1.75 4.5625 1.75 8C1.75 11.4688 4.53125 14.25 8 14.25ZM8 3.6875C8.71875 3.6875 9.3125 4.28125 9.3125 5C9.3125 5.75 8.71875 6.3125 8 6.3125C7.25 6.3125 6.6875 5.75 6.6875 5C6.6875 4.28125 7.25 3.6875 8 3.6875ZM9.75 11.625C9.75 11.8438 9.5625 12 9.375 12H6.625C6.40625 12 6.25 11.8438 6.25 11.625V10.875C6.25 10.6875 6.40625 10.5 6.625 10.5H7V8.5H6.625C6.40625 8.5 6.25 8.34375 6.25 8.125V7.375C6.25 7.1875 6.40625 7 6.625 7H8.625C8.8125 7 9 7.1875 9 7.375V10.5H9.375C9.5625 10.5 9.75 10.6875 9.75 10.875V11.625Z" fill="black" />
  </svg>
)